// extracted by mini-css-extract-plugin
module.exports = {"form":"MoneyCashForm_form__NGih_","button":"MoneyCashForm_button__gTu77"};